<!--
Desc: 首页底部 Banner 组件，通过 CMS 配置展示
-->
<template>
    <div v-if="bannerData && bannerData.fileid" class="home-banner">
        <div class="banner-item" v-on:click="handleBannerClick(bannerData)">
            <!-- Banner 背景图片 -->
            <img
                v-if="bannerData.fileid"
                :src="$util.imgSrc({ fileCode: bannerData.fileid })"
                :alt="bannerData.title || 'banner'"
                class="banner-bg-image"
            />
            <!-- 配置内容：收益率 -->
            <div
                class="banner-config return-rate"
                :class="Number(allud) > 0 ? 'add' : Number(allud) < 0 ? 'reduce' : ''"
            >
                {{ formatterRate(allud) }}
            </div>
            <!-- 配置内容：基金名称 -->
            <div class="banner-config fund-name">
                {{ currentFund ? currentFund.fundname : "" }}
            </div>
            <div class="banner-config fund-code">
                {{ fundcode }}
            </div>
        </div>
        <!-- 未认证投资者限制交易弹窗 -->
        <dalogChild width="520px" :dialogVisible.sync="showDialog"></dalogChild>
        <!-- 适当性风险确认对话框 -->
        <fund-sdx-dialog
            :fund="sdxFundInfo"
            :sdx-dialog-visible="sdxDialogVisible"
            v-on:dialogClosed="sdxDialogClose"
            v-on:dialogContinue="sdxDialogContinue"
        ></fund-sdx-dialog>
    </div>
</template>

<script>
import fundApi from "@/api/fund";
import dalogChild from "@/components/acctInfo/dalogChild.vue";
import fundSdxDialog from "@/components/form/fundSdxDialog";

export default {
    name: "HomeBanner",
    components: {
        dalogChild,
        fundSdxDialog
    },
    data() {
        return {
            bannerData: {},
            fundcode: "",
            allud: "", // 默认值，可从接口获取
            showDialog: false,
            currentFund: null, // 存储当前基金信息
            sdxFundInfo: {}, // 适当性基金信息
            sdxDialogVisible: false // 适当性对话框显示状态
        };
    },
    mounted() {
        this.loadBanner();
    },
    methods: {
        // 加载 Banner 数据
        async loadBanner() {
            // 使用 groupid 为 7 的 banner（首页底部banner）
            const { data: bannerRes } = await fundApi.getBanner({
                bannertype: "101",
                groupid: "7",
                pagesize: 3,
                pagenum: 1
            });
            if (bannerRes && bannerRes.list && bannerRes.list.length > 0) {
                this.bannerData = bannerRes.list[0];
                this.fundcode = bannerRes.list[0].linkurl;
                this.loadReturnRate();
            }
        },
        // 加载成立以来收益
        async loadReturnRate() {
            try {
                const fundRes = await this.fetchFundInfo();
                if (fundRes) {
                    this.allud = fundRes.allud || "";
                }
            } catch (e) {
                console.error("加载成立以来收益失败:", e);
            }
        },
        // 获取基金信息
        async fetchFundInfo() {
            if (this.currentFund) {
                return this.currentFund;
            }
            try {
                const fundRes = await fundApi.getFundLists({
                    fundcode: this.fundcode,
                    pagesize: 10,
                    pagenum: 1
                });
                if (fundRes.data && fundRes.data.list && fundRes.data.list.length > 0) {
                    this.currentFund = fundRes.data.list[0];
                    return this.currentFund;
                }
            } catch (e) {
                console.error("获取基金信息失败:", e);
            }
            return null;
        },
        // 点击 Banner 跳转
        handleBannerClick(item) {
            if (item.linkurl) {
                if (item.opentype === "6") {
                    // 跳转基金详情页
                    this.$util.toFundDetailPage(this.fundcode);
                } else if (item.opentype === "7") {
                    // 跳转购买页
                    this.buyFund();
                }
            }
        },
        // 购买基金
        async buyFund() {
            const fund = await this.fetchFundInfo();
            if (!fund) {
                return;
            }

            // 申购 22 认购 20
            const moduleId = fund.status == "1" ? "20" : "22";

            // 不允许进入交易页面交易
            const limitFlag = await this.$util.shouldShowCertificateDialog("0" + moduleId);
            if (limitFlag) {
                this.showDialog = true;
                return;
            }

            // OCR 校验
            this.$util.checkGtOcrModule(moduleId, "0", (res) => {
                if (res) {
                    this.executeFundBuy(fund);
                }
            });
        },
        // 执行基金购买（风险校验后）
        executeFundBuy(fund) {
            this.sdxFundInfo = {};
            const way = "20,22";
            fund._url = "buyfund";
            fund.proto = "buy";

            this.$util.fundRiskCheck(this, fund, (res) => {
                if (res) {
                    const isNeedSdxCheck = this.$util.isNeedSdxCheck(res);
                    if (!isNeedSdxCheck) {
                        res.way = way;
                        this.$util.grantTradeSdxAccessAndStoreFund(res._url, res);
                        this.$router.push({ name: res._url, query: { fundcode: res.fundcode } });
                        return;
                    }
                    this.$util.getSdxProtocol(res, (data) => {
                        if (data) {
                            const _x = Object.assign({}, data, { way: way });
                            this.sdxFundInfo = _x;
                            this.sdxDialogVisible = true;
                        }
                    });
                }
            });
        },
        // 适当性对话框关闭
        sdxDialogClose() {
            this.sdxDialogVisible = false;
        },
        // 适当性对话框继续
        sdxDialogContinue() {
            this.sdxDialogVisible = false;
            const fund = this.sdxFundInfo;
            if (fund && fund._url) {
                this.$util.grantTradeSdxAccessAndStoreFund(fund._url, fund);
                this.$router.push({ name: fund._url, query: { fundcode: fund.fundcode } });
            }
        },
        // 格式化收益率数据
        formatterRate(rate) {
            if (rate === "" || rate === null || rate === undefined) {
                return "--";
            }
            const prefix = Number(rate) > 0 ? "+" : "";
            return prefix + this.$util.fmtNum(rate) + "%";
        }
    }
};
</script>

<style lang="scss" scoped>
.home-banner {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 900px;
    margin-left: auto;
    margin-right: auto;

    .banner-item {
        position: relative;
        cursor: pointer;
        transition: opacity 0.2s;
        border-radius: 4px;
        overflow: hidden;
        width: 900px;
        height: 210px;

        &:hover {
            opacity: 0.9;
        }

        .banner-bg-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }

        .banner-config {
            position: absolute;
            pointer-events: none;
        }

        // 收益率：与"成立以来收益"文字左对齐
        .return-rate {
            left: 25px; // 与"成立以来收益"左对齐
            top: 75px;
            width: 180px;
            font-size: 34px;
            font-weight: 600;
            line-height: 1;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &.add {
                color: $risk5;
            }
            &.reduce {
                color: $risk1;
            }
        }

        // 基金名称：上边距 45px，限制在左侧区域内
        .fund-name {
            left: 223px;
            top: 35px;
            width: 300px; // 限制在左侧区域内
            font-size: 22px;
            font-weight: 500;
            color: var(--color-text-primary);
            line-height: 1;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        // 基金代码：上边距 75px
        .fund-code {
            left: 313px;
            top: 70px;
            width: 120px;
            font-size: 14px;
            text-align: center;
            color: var(--color-text-accent);
            line-height: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
</style>
